
import React, { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { TimeRange, getTimeRanges } from "@/components/TimeRangeSelector";
import VideosTab from "@/components/VideosTab";
import OverviewTab from "@/components/admin/OverviewTab";
import UsersTab from "@/components/admin/UsersTab";
import { User } from "@/components/admin/UserDetailView";
import { useAdminDashboardData } from "@/hooks/useAdminDashboardData";
import DashboardLayout from "@/components/admin/DashboardLayout";
import DashboardTabs from "@/components/admin/DashboardTabs";

const AdminDashboard = () => {
  const { toast } = useToast();
  const [timeRange, setTimeRange] = useState<TimeRange>(getTimeRanges()[2]); // Default to "Last 7 days"
  const [activeTab, setActiveTab] = useState("overview");
  const {
    isLoading,
    allUsers,
    overviewData,
    sourceBreakdownData,
    videoTimelineData,
  } = useAdminDashboardData(timeRange);

  const handleTimeRangeChange = (newRange: TimeRange) => {
    setTimeRange(newRange);
    toast({
      title: "Time range updated",
      description: `Data filtered for ${newRange.label}`
    });
  };

  const handleContactUser = (user: User) => {
    toast({
      title: "Contact initiated",
      description: `Contacting ${user.name || user.email} at ${user.email}`
    });
  };

  return (
    <DashboardLayout
      title="Admin Dashboard"
      description="Monitor metrics and manage users"
    >
      <DashboardTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        timeRange={timeRange}
        onTimeRangeChange={handleTimeRangeChange}
      >
        <TabsContent value="overview" className="space-y-6">
          <OverviewTab
            data={overviewData}
            sourceBreakdownData={sourceBreakdownData}
            videoTimelineData={videoTimelineData}
            timeRange={timeRange}
            onTimeRangeChange={handleTimeRangeChange}
            isLoading={isLoading}
          />
        </TabsContent>

        <TabsContent value="users" className="space-y-4">
          <UsersTab
            users={allUsers}
            onContactUser={handleContactUser}
            isLoading={isLoading}
          />
        </TabsContent>

        <TabsContent value="videos" className="space-y-4">
          <VideosTab />
        </TabsContent>
      </DashboardTabs>
    </DashboardLayout>
  );
};

export default AdminDashboard;
